import TeacherRoutes from './TeacherRoutes';

export default TeacherRoutes;
